import DocReady from 'es6-docready';
DocReady(function () {
  var modalMessageCta = document.querySelector('[data-element="modalMessage"]');
  if (modalMessageCta) {
    setTimeout(function () {
      modalMessageCta.click();
    }, 100);
  }
});